<script>
import options from "./ChatMessageToolbar.options"
export default options
</script>

<template>
    <div 
        class="nyk-chat-message-toolbar" 
        :aria-describedby="`item-${messageId}`"
        role="toolbar"
        :aria-label="`${labels.feedbackToolbarLabel}`"
    >
        <FeedbackToolbar
            :item-id="responseId"
            :labels="labels"
            @on-feedback="handleFeedback"
        />
        <div 
            v-if="isAiGenerated"
            class="nyk-chat-message-toolbar__ai-badge"
            role="img"
            :aria-label="labels.aiGeneratedLabel"
            :aria-describedby="`item-${messageId}`"
        >
            <span aria-hidden="true">{{ labels.aiGeneratedLabel }}</span>
            <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                <g clip-path="url(#clip0_4813_8141)">
                <path d="M7.5 2.5C8.605 2.5 9.5 1.605 9.5 0.5C9.5 1.605 10.395 2.5 11.5 2.5C10.395 2.5 9.5 3.395 9.5 4.5C9.5 3.395 8.605 2.5 7.5 2.5Z" stroke="#07094A" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M0.5 7.5C2.709 7.5 4.5 5.709 4.5 3.5C4.5 5.709 6.291 7.5 8.5 7.5C6.291 7.5 4.5 9.291 4.5 11.5C4.5 9.291 2.709 7.5 0.5 7.5Z" stroke="#07094A" stroke-linecap="round" stroke-linejoin="round"/>
                </g>
                <defs>
                <clipPath id="clip0_4813_8141">
                <rect width="12" height="12" fill="white"/>
                </clipPath>
                </defs>
            </svg>     
        </div>
    </div>
</template>